import { render, staticRenderFns } from "./MergeUsers.vue?vue&type=template&id=2ba4648a"
import script from "./MergeUsers.vue?vue&type=script&lang=js"
export * from "./MergeUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports